const schedulingURL = "./schedule";
const accountsURL = "./accounts";
const caseURL = "./case";
export const fetchFee = accountsURL + "/derecharge";
export const fetchAllContacts = accountsURL + "/fetchcontacts";
export const fetchStates = schedulingURL + "/stateList";
export const updateExistingContact = accountsURL + "/accountcontacts/update";
export const addNewContact = accountsURL + "/cfst/addnewcontact";
export const validateVin = schedulingURL + "/validation/vin";
export const checkVinCompatibility = schedulingURL + "/recommendations/vin";
export const getAccountInfo = schedulingURL + "/accountdetail/";
export const fetchMaterialList = schedulingURL + "/materials";
export const createNewCase = schedulingURL + "/createnewcase";
export const updateCase = schedulingURL + "/updatecase";
export const fetchSlots = schedulingURL + "/appointments";
export const fetchRescheduleReasonList = schedulingURL + "/reschedulereasons";
export const fetchSchedulingNotes = caseURL + "/cfst/getschedulingnotes";
export const reschedule = schedulingURL + "/reschedule";
export const newAddressValidationCall = schedulingURL + "/validateaddress";
export const getAllAppointments = schedulingURL + "/jobs";
export const addJob = schedulingURL + "/createjob";
export const getJobDetails = schedulingURL + "/jobdetail";
export const updateJob = schedulingURL + "/updatejob";
export const schedule = schedulingURL + "/createSchedule";
export const fetchVehicleAndAssetList = schedulingURL + "/vehicle";
export const closeCaseAndJob = schedulingURL + "/closecaseandjob";
export const getFeaturesByVin = schedulingURL + "/getdevicetypebyvin";
export const getVinControlUnits = schedulingURL + "/camerabyvehicleesn";
export const CFST_DASHBOARD_COUNT = `${schedulingURL}/jobanalytics`;
export const CFST_DASHBOARD_TRENDS = `${schedulingURL}/jobanalytics/trends`;
export const CFST_DERE_CASECOUNTS = `${caseURL}/derecasescount`;
